import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ClientPermission {
  module: string;
  operations: string[];
}

interface AuthState {
  isAuthenticated: boolean;
  profile?: any;
  permissions?: ClientPermission[];
}

const initialState: AuthState = {
  isAuthenticated: false,
  profile: undefined,
  permissions: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    addProfileData: (state, action: PayloadAction<any>) => {
      state.profile = action.payload;
    },
    setClientPermissions: (state, action: PayloadAction<ClientPermission[]>) => {
      state.permissions = action.payload;
    },
    login(state) {
      state.isAuthenticated = true;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.profile = undefined;
      state.permissions = undefined;
    },
  },
});

export const { login, logout, addProfileData, setClientPermissions } =
  authSlice.actions;
export default authSlice.reducer;

export const selectClientPermissions = (state: { auth: AuthState }) =>
  state.auth.permissions;